import React, { useEffect, useState, useRef } from "react";
import { Link, useSearchParams, useParams, useNavigate } from "react-router-dom";
import { useCart } from '../CartContext';
import placeholderImage from "../images/Placeholder.png";
import payAmex from "../images/payAmex.png";
import payApple from "../images/payApple.png";
import payDiscover from "../images/payDiscover.png";
import payGPay from "../images/payGPay.png";
import payKlarna from "../images/payKlarna.png";
import payMC from "../images/payMC.png";
import payVisa from "../images/payVisa.png";

import axios from "axios";
import { API_BASE_URL } from '../config';

function ProductDetail() {
  const { addToCart, updateQuantity, cart, removeFromCart } = useCart();
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [selectedSizeOrWeight, setSelectedSizeOrWeight] = useState(null);
  const [reviewCondition, setReviewCondition] = useState(null);
  const [cartItem, setCartItem] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [reviewerNames, setReviewerNames] = useState({});
  const visitFiredRef = useRef(false);
  const productImages = (product != null || product != "") ? product?.imageURL : null;

  useEffect(() => {
    // Fetch the product details from the backend
    axios.get(`${API_BASE_URL}/api/products/${encodeURIComponent(id)}`)
      .then((response) => setProduct(response.data))
      .catch((error) => console.error("Error fetching product details:", error));
  }, [id]);

  useEffect(() => {
    if (!product) return;
    // console.log(cart,product,cartItem)

    setCartItem(cart.filter(cartItem => cartItem["_id"] == product["_id"])[0])
  }, [cart, product, cartItem]);

  useEffect(() => {
    if (productImages != null) setSelectedImage(productImages?.[0])
  }, [productImages])

  useEffect(() => {
    sessionStorage.setItem('navigationSource', 'product');
  }, []);

  useEffect(() => {
    if (!product?.reviews) return;
    const orderIds = Object.values(product.reviews)
      .flat()
      .map(entry => entry[0])
      .filter(Boolean);
    if (orderIds.length === 0) return;
    axios.post(`${API_BASE_URL}/api/products/reviewer-names`, { orderIds })
      .then(res => setReviewerNames(res.data))
      .catch(() => { });
  }, [product]);

  useEffect(() => {
    if (!product || visitFiredRef.current) return;
    visitFiredRef.current = true;
    const w = window.innerWidth;
    const now = new Date();
    const isBotByWidth = w == null || w < 1;
    const isBotByWebdriver = navigator.webdriver === true;
    const isBotByTime = now.getHours() === 19 && now.getMinutes() === 0;
    const deviceType = (isBotByWidth || isBotByWebdriver)
      ? 'bot'
      : isBotByTime
        ? 'bot'
        : w >= 1024 ? 'desktop' : w >= 769 ? 'tablet' : 'mobile';
    axios.post(`${API_BASE_URL}/api/visits`, {
      productId: product._id,
      productName: product.name,
      clientDate: new Date().toISOString(),
      referral: sessionStorage.getItem('referral') || '',
      deviceType,
    }).catch(() => { });
  }, [product]);


  if (!product) {
    return <div>Product not found.</div>;
  }



  const splitName = product.name.split("(");
  let totalRating = 0;
  let totalRatingUsers = 0;
  for (let rating in product.reviews) {
    const ratingArray = product.reviews[rating];
    totalRating = totalRating + (Number(rating) * ratingArray.length);
    totalRatingUsers = totalRatingUsers + ratingArray.length;
  }
  const reviewIcons = [];

  for (let i = 0; i < 5; i++) {
    const avgRating = (totalRating == 0 && totalRatingUsers == 0) ? 0 : totalRating / totalRatingUsers;
    const starName = avgRating < (i + .24) ? "bi-star" : avgRating < (i + .74) && avgRating > (i + .24) ? "bi-star-half" : "bi-star-fill";
    const starIcon = React.createElement("i", { className: `star-icons bi ${starName}` });
    reviewIcons.push(starIcon);
  }

  function processVariations(productName, selectedVariation) {
    if (productName == undefined || selectedVariation == undefined) return;
    const varietyData = sessionStorage.getItem('variations');
    if (varietyData.length == 0) return;
    const varietyMap = varietyData ? new Map(JSON.parse(varietyData)) : [];

    const varietyOptions = varietyMap ? varietyMap.get(productName) : null;
    if (varietyOptions == undefined) return;
    const mappedVarietyOptions = varietyOptions.map(variety => (<Link className={selectedVariation == variety ? "product-variety-selected" : "product-variety-unselected"} to={`/product/${productName}(${variety})`}>{variety}</Link>));

    return mappedVarietyOptions;

  }
  return (
    <section>
      <div className="product-back-link-container">
        <Link className="product-back-link" to={-1} onClick={() => { if (localStorage.getItem('productScrollY') != null) { localStorage.setItem('cachedScrollY', localStorage.getItem('productScrollY')); } }}><i className="bi bi-arrow-left-short"></i>Back</Link>
      </div>
      <section className="product-flex-container">
        <article className="product-detail-image-container phone-display">
          <article className="product-detail-image" style={{ backgroundImage: `url(${selectedImage ? selectedImage : placeholderImage})` }}></article>
          <div className="product-detail-image-gallery">
            {productImages.map(imageIndex => {
              return (
                <div onClick={() => setSelectedImage(imageIndex)} style={{ backgroundImage: `url(${imageIndex})`, border: selectedImage == imageIndex ? "1px solid #1B344A" : "1px solid lightgrey" }}></div>
              )
            })}
          </div>
        </article>
        <article className="product-description-container">
          <div className="product-breadcrumbs-container"><Link to="/all">Shop</Link><i className="bi bi-chevron-right"></i><Link to={`/${product.category}`}>{product.category}</Link><i className="bi bi-chevron-right"></i><Link to={`/${product.category}?category=${encodeURIComponent(product.subcategory)}`}>{product.subcategory}</Link></div>

          <article className="product-detail-image-container computer-display">
            <article className="product-detail-image" style={{ backgroundImage: `url(${selectedImage ? selectedImage : placeholderImage})` }}></article>
            <div className="product-detail-image-gallery">
              {productImages.map(imageIndex => {
                return (
                  <div onClick={() => setSelectedImage(imageIndex)} style={{ backgroundImage: `url(${imageIndex})`, border: selectedImage == imageIndex ? "1px solid #1B344A" : "1px solid lightgrey" }}></div>
                )
              })}
            </div>
          </article>
          <h3>{splitName[0]}</h3>

          <div>{reviewIcons}{(totalRating == 0 && totalRatingUsers == 0) ? " Not yet rated" : ` (${totalRating / totalRatingUsers}) ${totalRatingUsers} rating${totalRatingUsers > 1 ? "s" : ""}`}</div>

          <h2>${product.price}</h2>

          <p>{product.description}</p>
          {splitName[1] == undefined ? "" : (
            <div className="product-weight-size-container">
              <span className="product-weight-size-title">
                Variation:
              </span>
              {processVariations(splitName[0], splitName?.[1]?.replace(")", ""))}
            </div>)}
          {product.quantity == 0 ? (<strong style={{ color: "red" }}>Out of Stock</strong>) : ""}
          {product.quantity == 0 ? "" : (
            <div className="product-quantity-container">
              <span className="product-quantity-title">
                Quantity:
              </span>
              <div className={`cart-products-item-input-container ${(cartItem?.quantity == 0 || cartItem?.quantity == undefined) ? "cart-products-option-removed" : ""}`}>
                <button onClick={() => {
                  if (cartItem?.quantity == undefined) return;
                  if (cartItem?.quantity == 1) removeFromCart(cartItem?.["_id"])
                  if (cartItem?.quantity > 1) updateQuantity(cartItem?.["_id"], (cartItem?.quantity - 1))
                }} className={`${cartItem?.quantity == 0 || cartItem?.quantity == undefined ? "cart-products-item-input-button-disabled" : ""}`}><i className="bi bi-dash-lg"></i></button>
                <p>{cartItem?.quantity ? cartItem.quantity : "0"}</p>
                <button onClick={() => {
                  addToCart(product)
                }} className={`${product?.quantity == cartItem?.quantity ? "cart-products-item-input-button-disabled" : ""}`}><i className="bi bi-plus-lg"></i></button>
              </div>
              <button onClick={() => {
                addToCart(product)
              }} className={`cart-products-add-to-cart ${cartItem?.quantity > 0 ? "cart-products-option-removed" : ""}`}>Add to Cart <i className="bi bi-cart-plus"></i></button>
              <div style={{ width: "100%", borderTop: "1px solid lightgray", marginTop: "1rem", paddingTop: "1rem" }}>
                <small><b>Payment Methods</b></small>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "6px", flexWrap: "wrap" }}>
                {[payVisa, payMC, payAmex, payDiscover, payApple, payGPay, payKlarna].map((src, i) => (
                  <img key={i} src={src} alt="" style={{ height: "28px", width: "auto", display: "block", boxShadow: "rgba(0, 0, 0, 0.2) 0px 0px 3px 0px", borderRadius: "4px", padding: "3px" }} />
                ))}
              </div>
              <div style={{ width: "100%" }}>
                <small>Secure checkout via <i className="bi bi-stripe" style={{ color: "rgb(99, 91, 255)" }}></i></small>
              </div>

              <small style={{fontSize:"0.75rem", marginTop:"0.5rem"}}><b>Shop with confidence: </b>We accept returns and exchanges within 15 days of receiving your order, provided the items are unused and in their original condition. Botanicals and incense are final sale due to hygiene reasons. For more information, please reach out to us via our <a href="/contact" data-discover="true" style={{textDecoration:"none", color:"#3e5b74",fontWeight:"700"}}>Contact</a> section.</small>
            </div>)}

          {/* <button disabled={true} className="product-add-cart-button" type="button" onClick={()=>addToCart(product)}>Add to Cart <i className="bi bi-cart-plus"></i></button> */}
        </article>

      </section>
      <section className="product-reviews-container">
        <h2>{totalRatingUsers} reviews</h2>
        <section className="product-reviews-flex-container">
          <article>
            <h3>Overall Rating</h3>
            <div className="product-total-ratings-container"><h2>{(totalRating == 0 && totalRatingUsers == 0) ? 0 : totalRating / totalRatingUsers}</h2>{reviewIcons}</div>
            {Object.keys(product.reviews).reverse().map(rating => {
              return (
                <div className="product-total-ratings-subcontainer"><b>{rating}</b>
                  <div>
                    <div style={{ width: `${product.reviews[rating].length ? (product.reviews[rating].length / totalRatingUsers) * 100 : "0"}%` }}></div>
                  </div>
                  <span onClick={() => {
                    const starIconArray = [];
                    for (let index = 1; index < 6; index++) {
                      const starName = Number(rating) >= index ? "bi-star-fill" : "bi-star";
                      const starIcon = React.createElement("i", { className: `star-icons bi ${starName}` });
                      starIconArray.push(starIcon)
                    }
                    setReviewCondition(starIconArray);
                  }}>{product.reviews[rating].length}</span>
                </div>
              )
            })}
          </article>
          <article>
            <h3 className="product-reviews-parent-condition-container">Viewing: {reviewCondition ? (<><div className="product-review-condition-container">{reviewCondition}</div><span className="product-reviews-condition-remove" onClick={() => { setReviewCondition(null) }}><i className="bi bi-x-lg"></i></span></>) : "All"}</h3>
            {totalRatingUsers == 0 && !reviewCondition ? (<i className="product-reviews-no-comments">No reviews yet.</i>) : ""}
            {Object.keys(product.reviews).reverse().map(rating => {
              const conditionCount = !reviewCondition ? null : reviewCondition.filter(icon => icon.props.className.includes("bi-star-fill")).length;
              if (conditionCount) {
                if (Number(conditionCount) != Number(rating)) return;
                if (Number(conditionCount) == Number(rating) && product.reviews[rating].length == 0) {
                  return (
                    <i className="product-reviews-no-comments">No reviews with this criteria yet.</i>
                  );
                }
              }
              for (let review of product.reviews[rating]) {
                const reviewTempIcons = [];
                for (let i = 0; i < Number(rating); i++) {
                  const starIcon = React.createElement("i", { className: `star-icons bi bi-star-fill` });
                  reviewTempIcons.push(starIcon);
                }
                if (Number(rating) != 5) {
                  for (let j = 0; j < (5 - Number(rating)); j++) {
                    const starIcon = React.createElement("i", { className: `star-icons bi bi-star` });
                    reviewTempIcons.push(starIcon);
                  }
                }
                return (
                  <div className="product-total-ratings-comment-container">
                    <div className="product-total-ratings-comment-subcontainer">

                      <div className="product-total-ratings-comment-avatar"><i className="bi bi-person-fill"></i></div>
                      <div className="product-total-ratings-comment-flex-info">
                        <b>{reviewerNames[review[0]] || 'Verified Buyer'}</b>
                        <i>{review[2] ? (() => { const d = new Date(review[2]); return isNaN(d) ? review[2] : `${String(d.getMonth() + 1).padStart(2, '0')}/${String(d.getDate()).padStart(2, '0')}/${d.getFullYear()}`; })() : ''}</i>
                      </div>
                      <div className="product-total-ratings-comment-stars">{reviewTempIcons}</div>
                    </div>
                    <p>{review[1]}</p>

                  </div>
                )
              }

            })}</article>
        </section>
      </section>
    </section>
  );
}

export default ProductDetail;

